import { render } from "./CvView.vue?vue&type=template&id=228f925e&scoped=true"
const script = {}

import "./CvView.vue?vue&type=style&index=0&id=228f925e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228f925e"]])

export default __exports__